export const money = (n) => `$${Number(n || 0).toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const fmtDate = (iso) => {
  if (!iso) return '-';
  const [y, m, d] = String(iso).slice(0, 10).split('-');
  return `${d}/${m}/${y}`;
};

export const waLink = (phone, text) => `https://wa.me/${String(phone || '').replace(/\D/g, '')}?text=${encodeURIComponent(text)}`;

export const mailLink = (email, subject, body) => `mailto:${email || ''}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

export const STATE_BADGE = {
  pagada: 'bg-green-100 text-green-700',
  parcial: 'bg-amber-100 text-amber-700',
  hoy: 'bg-blue-100 text-blue-700',
  por_vencer: 'bg-amber-100 text-amber-700',
  pendiente: 'bg-slate-100 text-slate-600',
  vencida: 'bg-red-100 text-red-700',
};

export const installmentText = (it) =>
  `Hola ${it.client?.name || ''}, te recordamos tu cuota #${it.number}/${it.total_installments} de ${money(it.balance)} ` +
  `(${it.invoice_number}) con vencimiento ${fmtDate(it.due_date)}${it.days_overdue ? ` — ${it.days_overdue} día(s) de atraso` : ''}. Celular Beach.`;

export const statementText = (st) => {
  const c = st.client; const s = st.summary;
  const pend = st.installments.filter((i) => i.state !== 'pagada')
    .map((i) => `• Cuota #${i.number} ${fmtDate(i.due_date)} ${money(i.balance)} (${i.state})`).join('\n');
  const devs = st.devices.map((d) => `• ${d.name} (${d.invoice_number})`).join('\n');
  return `*Estado de cuenta Celular Beach*\n${c.name} · C.I. ${c.cedula_rif}\n\nEquipos:\n${devs || '-'}\n\nTotal: ${money(s.total_bought)} · Pagado: ${money(s.total_paid)} · Saldo: ${money(s.balance)}\nCuotas pagadas: ${s.installments_paid} · Pendientes: ${s.installments_pending} · Vencidas: ${s.installments_overdue}\n\n${pend}`;
};
